import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { CommonFunctionsService, NotificationsService } from '@angular/synthrone-design/services';
import { Observable } from 'rxjs/Rx';
import { ApiService } from '@angular/synthrone-design/services/api/api.service';
import { MessagesService } from '@angular/synthrone-design/services/messages/messages.service';
import { environment } from '@synthroneEnvironments/environment';
import { ClientServiceSDK, ApplicationServiceSDK } from 'ms-client-angular-sdk';
import { UserServiceSDK } from 'ms-user-angular-sdk';
import { NotificationBarModel } from '@synthroneApp/models/notification-bar/notification-bar.model';
import { MatDialog } from '@angular/material';
import { NotificationBarEditorComponent } from '@synthroneApp/components/forms/notification-bar-editor/notification-bar-editor.component';
import { switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { ConfirmationComponent } from '@angular/synthrone-design/components';
import { ErrorComponent } from '@angular/synthrone-design/components';

@Component({
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})

export class NotificationsViewComponent implements OnInit {

  @ViewChild('table') table;

  configColumns = {
    title: {
      label: 'Message Title',
      truncate: true,
      style: {
        flexGrow: 1.5
      }
    },
    type: {
      label: 'Message Type',
      truncate: true,
      style: {
        flexGrow: 0.8
      }
    },
    app: {
      label: 'Application',
      truncate: true,
      style: {
        flexGrow: 0.6
      }
    },
    client: {
      label: 'Organization',
      truncate: true,
      style: {
        flexGrow: 0.6
      }
    },
    visibleFrom: {
      label: 'Visible from',
      truncate: true,
      style: {
        flexGrow: 0.8
      }
    },
    visibleTo: {
      label: 'Visible to',
      truncate: true,
      style: {
        flexGrow: 0.8
      }
    }
  };

  senderApps;
  notificationBarsenderApps;

  messageTypes = [
    {
      type: 'info',
      label: 'Info'
    },
    {
      type: 'error',
      label: 'Error'
    },
    {
      type: 'warning',
      label: 'Warning'
    },
    {
      type: 'important',
      label: 'Important'
    }
  ];

  notificationBarMessageTypes = [
    {
      type: 'INFO',
      label: 'Info'
    },
    {
      type: 'ERROR',
      label: 'Error'
    },
    {
      type: 'WARNING',
      label: 'Warning'
    },
    {
      type: 'NOTICE',
      label: 'Important'
    }
  ];

  notificationData = {
    bar: {
      title: '',
      type: '',
      app: '',
      client: '',
      visibleFrom: '',
      visibleTo: '',
      status: '',
      message: '',
      url: ''
    },
    bell: {
      senderApp: 'synthrone.manager',
      messageType: "info",
      message: "Lorem ipsum",
      selectedOrganization: '',
      selectedUser: '',
      url: null,
      thumb: null
    }
  }

  appSlugNameMap = {};
  organizationPlanetNameMap = {};
  originalBarTableData;

  organizations;
  notificationBarOrganizations;
  users;

  constructor(
    @Inject(CommonFunctionsService) public commonFunctions,
    private api: ApiService,
    private messagesService: MessagesService,
    private clientService: ClientServiceSDK,
    private applicationService: ApplicationServiceSDK,
    private userService: UserServiceSDK,
    public dialog: MatDialog,
    private notificationsService: NotificationsService) { }

  ngOnInit() {
    Observable.forkJoin([
      this.api.makeSDKRequest(this.clientService, "clientsGet"),
      this.api.makeSDKRequest(this.applicationService, "applicationsGet")
    ]).subscribe(([clients, apps]) => {
      this.organizations = [...(clients as any[])];
      this.notificationBarOrganizations = [...(clients as any[])];
      this.organizations.unshift({
        name: "All",
        planet: "",
      });
      this.notificationBarOrganizations.unshift({
        name: "All",
        planet: "_ALL_",
      });
      this.notificationData.bell.selectedOrganization = this.organizations[0].planet;

      this.senderApps = [...(apps as any[])];
      this.notificationBarsenderApps = [...(apps as any[])];
      this.notificationBarsenderApps.unshift({
        name: "All",
        slug: "_ALL_",
      });
      this.appSlugNameMap = this.notificationBarsenderApps.reduce((map, item) => {
        map[item.slug] = item.name;
        return map;
      }, {});
      this.organizationPlanetNameMap = this.notificationBarOrganizations.reduce((map, item) => {
        map[item.planet] = item.name;
        return map;
      }, {});
    });
  }

  fakeRead = () => {
    return Observable.of(true);
  }

  orgChange = (event) => {
    this.users = null;
    if (event.value != "") {

      let orgPlanet;
      orgPlanet = this.organizations.filter(org => {
        return org.planet == event.value;
      })[0].planet;
      this.api.makeSDKRequest(this.userService, "getUsers", false, { planet: orgPlanet, projection_group: 'compact' }).subscribe((res) => {
        this.users = res;
        this.users.unshift({
          name: "All",
          email: "",
        });
        this.notificationData.bell.selectedUser = this.users[0].email;
      });
    }
  }

  notificationPreview = (): Observable<any> => {
    return Observable.of([
      { "id": "1", "sender": this.notificationData.bell.senderApp, "message": this.notificationData.bell.message, "is_read": false, "created": (new Date()).toISOString(), "type": this.notificationData.bell.messageType, "url": this.notificationData.bell.url, "thumb": this.notificationData.bell.thumb }
    ]);
  }


  sendNotification = () => {
    this.api.postURLSeachParams('/notifications/add', {
      senderapp: this.notificationData.bell.senderApp,
      client: this.notificationData.bell.selectedOrganization,
      user: this.notificationData.bell.selectedUser,
      type: this.notificationData.bell.messageType,
      message: this.notificationData.bell.message,
      url: this.notificationData.bell.url,
      thumb: this.notificationData.bell.thumb
    }, environment.api.notifications.host, {}).catch(err => {
      this.messagesService.showSnack(err, "error");
      return Observable.throw(err);
    }).subscribe(res => {
      this.messagesService.showSnack("Notification sent");
    });
  }

  getTableData = (limit, offset, sortBy, sortOrder): Observable<any> => {
    return this.api.getData('/notification-bar', {}, environment.api['notifications'].host).pipe(
      switchMap((res: any) => {
        this.originalBarTableData = res;
        let tableData = res.map((item) => {
          const currentTime = Date.now();
          let newItem = JSON.parse(JSON.stringify(item)); // Deep copy
          newItem.app = this.appSlugNameMap[item.app];
          newItem.client = this.organizationPlanetNameMap[item.client];
          newItem.type = this.notificationBarMessageTypes.find(type => type.type === item.type).label;
          newItem.isLive = item.status === 'ACTIVE' && item.visibleFrom * 1000 < currentTime && item.visibleTo * 1000 > currentTime;
          newItem.visibleFrom = moment(item.visibleFrom * 1000).format('DD/MM/YYYY HH:mm');
          newItem.visibleTo = moment(item.visibleTo * 1000).format('DD/MM/YYYY HH:mm');
          return newItem;
        });
        return Observable.of({ data: tableData, total: res.length });
      })
    );
  }

  onButtonClick = (event: { data: NotificationBarModel, mode: 'create' | 'preview' }): void => {
    if (event.mode === 'create') {
      this.api.postData('/notification-bar', event.data, environment.api['notifications'].host).catch((error: any) => {
        this.showError(error);
        return Observable.throw(error)
      }).subscribe((response) => {
        this.refreshTable();
      });
    }

    if (event.mode === 'preview') {
      this.createNotificationBarPreview(event.data);
    }
  }

  createNotificationBarPreview = (notification: NotificationBarModel): void => {
    const previewData = { ...notification };
    previewData.visibleFrom = Date.now();
    previewData.visibleTo = (Date.now() + 100000);
    this.notificationsService.showPreviewNotification(previewData);
  }

  editRow = (row: NotificationBarModel): void => {
    const originalRow = this.originalBarTableData.find(r => r.id === row.id);

    this.dialog.open(NotificationBarEditorComponent, {
      width: '800px',
      data: {
        types: this.notificationBarMessageTypes,
        apps: this.notificationBarsenderApps,
        organizations: this.notificationBarOrganizations,
        initialData: originalRow
      }
    }).afterClosed().subscribe(result => {
      if (!result || typeof result !== 'object') {
        return;
      }
      this.refreshTable();
    });
  }

  pauseStartRow = (row: NotificationBarModel): void => {
    this.dialog.open(ConfirmationComponent, {
      data: {
        message: `Are you sure you want to ${row.status === 'ACTIVE' ? 'deactivate' : 'activate'} this notification bar?`
      }
    }).afterClosed().subscribe((response) => {
      if (response == "proceed") {
        const params: any = {
          status: row.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
        };
        this.api.patchData(`/notification-bar/${row.key}`, params, environment.api['notifications'].host).catch((error: any) => {
          this.showError(error);
          return Observable.throw(error)
        }).subscribe((response) => {
          this.refreshTable();
        });
      }
    });
  }

  deleteRow = (row: NotificationBarModel): void => {
    this.dialog.open(ConfirmationComponent, {
      data: {
        message: 'Are you sure you want to remove this notification bar? Removal is irreversible.'
      }
    }).afterClosed().subscribe((response) => {
      if (response == "proceed") {
        const params: any = {
          id: row.id,
        };
        this.api.deleteData(`/notification-bar/${row.key}`, params, environment.api['notifications'].host).catch((error: any) => {
          this.showError(error);
          return Observable.throw(error)
        }).subscribe((response) => {
          this.refreshTable();
        });
      }
    });
  };

  refreshTable = (): void => {
    this.table.getData()
  };

  showError = (message: string): Observable<any> => {
    let dialogRef = this.dialog.open(ErrorComponent, {
      data: {
        message: message
      }
    });
    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/views/notifications/notifications.component.ts